import React, {useState} from 'react';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

export const HeadUserFeedback = (props) => {
	/* Destructuring the props object. */
	const {TipoNotificaciones, cambioNotificaciones} = props;

	/* A React Hook. */
	const [first, setfirst] = useState('Agencias');

	/* An array of objects. */
	const optio = [
		{label: 'Pagadas y no pagadas', value: 'todas'},
		{label: 'No pagadas', value: 'noPagado'},
		{label: 'Pagadas', value: 'pagado'},
	];
	/**
	 * A function that is called when the user changes the value of the dropdown.
	 */
	const handleChangeEstado = (event) => {
		console.log(event.value);
	};

	return (
		<div className='headUserFeedback'>
			<div className='superiorHeadContentUsuarios'>
				<div>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='40'
						height='40'
						fill='currentColor'
						className='bi bi-table'
						viewBox='0 0 16 16'
					>
						<path d='M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z' />
					</svg>
				</div>
				<div className='centrador titleHeadHistorialFacturas'>User Feedback</div>
			</div>
			<div className='separador' />
			<div className='filtrosUsuario'>
				<div className='inputFechaFacturas'>
					<input type='date' />
				</div>
				<div className='inputFechaFacturas'>
					<input type='date' />
				</div>
				<div className='inputFechaFacturas'>
					<input type='text' />
				</div>
				<div className='inputFechaFacturas'>
					<Dropdown
						className='miDropDown'
						options={optio}
						onChange={handleChangeEstado}
						value={first}
						placeholder='Select an option'
					/>
				</div>
			</div>
			<div className='separador' />
			<div className='menuUserFeedback BotonesSuperiorPresupuestos'>
				<div
					className={TipoNotificaciones[0][0]}
					onClick={() => cambioNotificaciones(0)}
				>
					<div className='centrador'>{TipoNotificaciones[0][1]}</div>
				</div>
				<div
					className={TipoNotificaciones[1][0]}
					onClick={() => cambioNotificaciones(1)}
				>
					<div className='centrador'>{TipoNotificaciones[1][1]}</div>
				</div>
				<div
					className={TipoNotificaciones[2][0]}
					onClick={() => cambioNotificaciones(2)}
				>
					<div className='centrador'>{TipoNotificaciones[2][1]}</div>
				</div>
			</div>
		</div>
	);
};
